module.exports = __webpack_public_path__ + "src/img/sportIcon.31780503.svg";